export const AUTH_TOKEN_KEY = 'auth_token';
export const DEFAULT_VALUES_QUERY_KEY = 'default_values';
export const ACCREDITED_CONTACTS_QUERY_KEY = 'accredited_contacts';
export const USER_ENTOURAGE_QUERY_KEY = 'user_entourage';
export const CHAMPIONSHIP_PLAYERS_QUERY_KEY = 'championship_players';
export const CHAMPIONSHIP_CADDIES_QUERY_KEY = 'championship_caddies';
export const UPDATE_MUTATION_KEY = 'update';
